import Color from 'color';
import { px2em } from 'ksk/styledComponents/functions';
import { device } from 'ksk/styledComponents/mixins';
import { defaultThemeColor, kskTheme } from 'ksk/styledComponents/themes';
import styled, { css } from 'styled-components';

const Main = styled.main`  
  background: ${ kskTheme.backgroundColor };
  border: 1px solid transparent;
  transition: background 1s ease;
  

  color: ${ kskTheme.text };

  ${device.phone(css`
    padding: 0 .5em;
    min-height: calc(100vh - ${px2em(454)} );
  `)}

  ${device.tablet(css`
    padding: 0 .5em;
    min-height: calc(100vh - ${px2em(410)});
  `)}


  ${device.desktop(css`
    padding: 0 6em 0 6em;
    // padding: 0 ${px2em(30)} 0 ${px2em(60)};
    min-height: calc(100vh - ${px2em(420)});
  `)}
`;

export const S = {
  Main
};
